import { createSlice } from "@reduxjs/toolkit";
import { fetchTaskStatus } from "../documentUploadApi";

const fetchTaskStatusSlice = createSlice({
    name: "fetchTaskStatus",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        resetTaskStatus: (state) => {
            state.data = [];  // or null, if you prefer
            state.error = null;
            state.loading = false;
        },
        setTaskId: (state, action) => {
            const { communityId, taskId } = action.payload;
            state[communityId] = taskId;
        },
        clearTaskId: (state, action) => {
            const { communityId } = action.payload;
            delete state[communityId];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTaskStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTaskStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchTaskStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetTaskStatus, setTaskId, clearTaskId } = fetchTaskStatusSlice.actions;
export default fetchTaskStatusSlice.reducer;
